<template lang="pug">
el-dialog(
  :id='`app-${dialog.type}`'
  lock-scroll
  :custom-class='`app-${dialog.type} ${dialog.customClass}`'
  :visible='dialog.visible'
  :title='dialog.title'
  :top='dialog.top'
  :width='dialog.width'
  :fullscreen='fullscreenList.includes(dialog.type)'
  :before-close="beforeCancel"
  :close-on-click-modal='dialog.closeOnClickModal')
  div(v-if="dialog.slot" :slot="dialog.slot" class="el-message-box__title")
    span(v-if='dialog.title') {{dialog.title}}
    span(class="title-description" v-if='dialog.description') {{dialog.description}}
    component(:is='dialog.titleComponent')
  component(:is='dialog.component' :key='dialog.key')
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { dialogCommon } from '@/mixin'
export default {
  name: 'app-dialog',
  data () {
    return {
      fullscreenList: ['overview'],
    }
  },
  mixins: [ dialogCommon ],
  computed: {
    ...mapState('home', ['dialog']),
  },
  methods: {
    ...mapActions('home', ['changeGlobalDialog']),
    beforeCancel () {
      this.dialogHide()
    },
  },
}
</script>

<style scoped lang="scss">
#app-overview{
  width: 96%;
  height: 94%;
  margin: 2%;
  .title-description {
    margin-left: 30px;
    font-size: 18px;
    color: #303133;
  }
}
.el-dialog__body {
  padding-top: 0px;
  padding-bottom: 10px;
}
.title-description {
    margin-left: 30px;
    font-size: 14px;
    color: rgb(224, 91, 91);
}
</style>
